import React, { useState, useEffect } from 'react';
import ProductsPage from '../../Components/ProductsPage/ProductsPage';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import './PageProductos.css';
import HeaderBack from '../../Components/HeaderBack/HeaderBack';

export default function PageProductos() {
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        // Scroll suave al cargar en móvil
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        
        // Marcar que las imágenes han comenzado a cargar
        setImagesLoaded(true);
    }, []);

    return (
        <div className="productos-page">
            {/* Encabezado con imagen de fondo */}
            <div className='bgPage' style={{ 
                backgroundImage: imagesLoaded ? 
                    `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/ban.jpg)` : 
                    'none',
                backgroundColor: imagesLoaded ? 'transparent' : 'var(--color1)'
            }}>
                <HeaderBack title='Productos' />
                <div className="breadcrumb">
                    <Anchor to="/">
                        <FontAwesomeIcon icon={faHome} /> Inicio
                    </Anchor>
                    <span>|</span>
                    <Anchor to=''>
                        Productos
                    </Anchor>
                </div>
            </div>

            <ProductsPage />
        </div>
    );
}